import { Box, Grid, Tooltip} from "@mui/material";
import {
  BackButton,
  BackgroundStyle,
  BigHeading,
  ListContainer,
  SearchingBoxContainer,
  LongBlueButton,
  WhiteContainer,
  LabelContainer,
  ButtonContainer,
  WorkDetailContainer,
  ShortBlueButton,
} from "../assets/style";
import RecordTable, { TableHeader } from "../components/RecordTable";
import { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import ProjectBar from "../components/ProjectBar";
import FormLongLabel from "../components/FormLongLabel";
import { useLocation, useNavigate } from "react-router-dom";
import MainContent from "../components/MainContent";
import BigMapCard from "../components/MapBigCard";
import { entryPageName } from "../components/PageName";
import {
  useLazyGetRecordingsByScheduleIdQuery,
  useLazyGetScheduleByScheduleIdQuery,
  useLazyGetWorkScheduleFileQuery,
} from "../features/schedule/scheduleSlice";
import { useLazyGetProjectByIdQuery } from "../features/project/projectSlice";
import { useTranslation } from "react-i18next";
import { DocumentTypeMap } from "../models/WorkScheduleModel";
import {
  selectAccessToken,
  selectPermissions,
} from "../features/auth/authSlice";
import { useSelector } from "react-redux";
import { Permissions } from "../utils/Permissions";
import { formatDateTime } from "../utils/dateTimeFormmater";
import { truncateFileName } from "../utils/fileNameUtils";

const EntryDetailPage = () => {
  const { t, i18n } = useTranslation();
  const getLocation = useLocation();
  const entry = getLocation.state?.entry;
  const project = getLocation.state?.project;
  const location = getLocation.state?.location;

  const [riskAssessment, setRiskAssessment] = useState<boolean>(false);
  const [workPermit, setWorkPermit] = useState<boolean>(false);
  const [equipmentChecklist, setEquipmentChecklist] = useState<File[] | null>(
    null
  );
  const [riskAssessmentFile, setRiskAssessmentFile] = useState<File[] | null>(null);
  const [workPermitFile, setWorkPermitFile] = useState<File[] | null>(null);
  const workPermitFileInputRef = useRef<HTMLInputElement>(null);
  const riskAssessmentFileInputRef = useRef<HTMLInputElement>(null);

  const [getScheduleQuery, scheduleData] =
    useLazyGetScheduleByScheduleIdQuery();
  const [getProjectQuery, projectData] = useLazyGetProjectByIdQuery();
  const [getRecordingsByScheduleIdQuery, recordings] =
    useLazyGetRecordingsByScheduleIdQuery();
  const [getWorkScheduleFile] = useLazyGetWorkScheduleFileQuery();
  const workType = scheduleData?.data?.workType;

  const permissions = useSelector(selectPermissions);
  const accessToken = useSelector(selectAccessToken);

  const navigate = useNavigate();
  const [selectPosition, setSelectPosition] = useState({
    projectNumber: 1,
    projectName: "",
    code: "",
    name: "",
    lat: 22.32538,
    lng: 114.18028,
    date: "",
  });

  // Add a new state to track if position is loaded
  const [isPositionLoaded, setIsPositionLoaded] = useState(false);

  // const documentTypeMap: DocumentTypeMap = {
  //   ra: {
  //     setState: setRiskAssessmentFile,
  //   },
  //   wp: {
  //     setState: setWorkPermitFile,
  //   },
  //   ec: {
  //     setState: setEquipmentChecklist,
  //   },
  // };

  useEffect(() => {
    scheduleData?.data?.siteDocements?.forEach((document: any) => {
      const documentType = document.type;
      setRiskAssessmentFile(scheduleData?.data?.siteDocements?.filter((document: any) => document.type === "ra"));
      setWorkPermitFile(scheduleData?.data?.siteDocements?.filter((document: any) => document.type === "wp"));
      setEquipmentChecklist(scheduleData?.data?.siteDocements?.filter((document: any) => document.type === "ec"));
    });

    if (scheduleData?.isSuccess) {
      var startTime = dayjs(
        scheduleData.data.workDate + " " + scheduleData.data.startTime,
        "dd/MM/yyyy HH:mm"
      );
      var now = dayjs();
      if (now.isSame(startTime) || now.isAfter(startTime))
        getRecordingsByScheduleIdQuery(entry?.id);
    }
  }, [getScheduleQuery, scheduleData]);

  useEffect(() => {
    handleProjectData(entry?.id);
  }, []);

  const handleProjectData = async (curWorkerStataus: any) => {
    try {
      if (localStorage.accessToken && entry?.id) {
        getScheduleQuery({
          id: entry?.id,
        }).then((schedule: any) => {
          if (schedule.status == "fulfilled") {
            const newPosition = {
              projectNumber: schedule?.data?.projectNumber,
              projectName: schedule?.data?.projectNumber,
              code: schedule?.data?.locationNumber,
              name: schedule?.data?.locationName,
              lat: schedule?.data?.lat,
              lng: schedule?.data?.lng,
              date: schedule?.data?.workDate,
              isRiskAssessmentOpened: schedule?.data?.isRiskAssessmentOpened,
              isWorkPermitOpened: schedule?.data?.isWorkPermitOpened,
            };
            setSelectPosition(newPosition);
            setIsPositionLoaded(true);
            setRiskAssessment(schedule?.data?.isRiskAssessmentOpened);
            setWorkPermit(schedule?.data?.isWorkPermitOpened);
          }
        });

        getProjectQuery(project).then((project: any) => {
          if (project.status == "fulfilled") {
            // console.log("getProjectQuery", project?.data)
          }
        });
      }
    } catch (error) {
      alert("An error occurred. Please refresh (F5) or login again.");
      console.log(error);
    } finally {
      // console.log("workerStates", workerStates)
    }
  };

  const handleRiskAssessment = () => {

    navigate("/risk-assessment", {
      state: {
        mode: 'view',
        entry: entry,
        project: project,
        position: selectPosition,
        scheduleID: entry.id,
      }
    });
}

  const handleWorkPermit = () => {

      navigate("/work-permit", {
        state: {
          mode: 'view',
          entry: entry,
          project: project,
          position: selectPosition,
          scheduleID: entry.id,
        }
      });
  }

  const EquipmentColumns: TableHeader[] = [
    {
      field: "equipmentTypeId",
      headerName: t("Type"),
      width: 200,
      isSortable: true,
    },
    {
      field: "rfidNumber",
      headerName: t("RFID No."),
      width: 200,
      isSortable: false,
    },
    {
      field: "equipmentNumber",
      headerName: t("Equipment No."),
      width: 200,
      isSortable: false,
    },
    {
      field: "equipmentName",
      headerName: t("Equipment Name"),
      width: 400,
      isSortable: false,
    },
    {
      field: "manufacturer",
      headerName: t("Brand / Manufacturer"),
      width: 300,
      isSortable: true,
    },
    {
      field: "modelNumber",
      headerName: t("Model No."),
      width: 200,
      isSortable: false,
    },
    // { field: 'purchaseDate', headerName: 'Purchase Date', width: 300, isSortable: false },
    // { field: 'expiryDate', headerName: 'Expiry Date', width: 300, isSortable: false },
    // { field: 'certDueDate', headerName: 'Next Cal. / Cert Due Date', width: 200, isSortable: false },
    // { field: 'calPeriod', headerName: 'Cal. Period', width: 200, isSortable: false },
    // { field: 'certification', headerName: 'Certification', width: 200, isSortable: false },
    // { field: 'qrCode', headerName: 'QR Code', width: 200, isSortable: false },
  ];

  // 更新 getLink 函數以處理長檔案名稱
  const getLink = function (file: any) {
    if (file) {
      // 處理檔案名稱截斷
      const truncateFileName = (fileName: string, maxLength: number = 40) => {
        if (fileName.length <= maxLength) {
          return fileName;
        }

        const extension = fileName.split('.').pop();
        const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.'));
        const maxNameLength = maxLength - (extension ? extension.length + 1 : 0) - 3; // 3 for "..."

        if (nameWithoutExt.length <= maxNameLength) {
          return fileName;
        }

        return `${nameWithoutExt.substring(0, maxNameLength)}...${extension ? '.' + extension : ''}`;
      };

      return (
        <Tooltip title={file.name} placement="top" arrow>
          <a
            onClick={async () => {
              await getFile(file.id, file.name, file.contentType);
            }}
            href={"javascript:;"}
            target="_self"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              maxWidth: '250px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textDecoration: 'none',
              color: '#1976d2',
              cursor: 'pointer'
            }}
          >
            {truncateFileName(file.name, 35)}
          </a>
        </Tooltip>
      );
    } else {
      return "None";
    }
  };
  const getFile = async function (id: string, name: string, type: string) {
    try {
      const dataUrl = await getWorkScheduleFile(id).unwrap();
      const blob = await fetch(dataUrl).then((r) => r.blob());
      const file = new File([blob], name, { type: type });
      displayImageInNewTab(file, name);
    } catch (error) {
      alert("fails to open the file.");
      console.error(error);
      // navigate('/worker-detail', { state: { workerID: workerId } })
    } finally {
    }
  };

  const displayImageInNewTab = function (blob: Blob, filename: string) {
    const imageUrl = URL.createObjectURL(blob);
    const newTab = window.open(imageUrl);
  };

  const displayEquipments = function () {
    var workerCount = scheduleData?.data?.workers.filter(
      (x: any) => x.typeId === 3
    ).length;
    for (var i = 0; i < workerCount; i++) { }
  };

  return (
    <MainContent type={entryPageName}>
      <BackgroundStyle sx={{ zIndex: 0 }}>
        <ListContainer className="data-table-overide-styles">
          <BigHeading>{t("Work Schedule Detail")}</BigHeading>
          {entry?.status !== "completed" && entry?.status !== "cancelled" &&
            permissions.includes(Permissions.EntryEdit) && (
              <LongBlueButton
                style={{ marginLeft: "28px" }}
                onClick={() => {
                  navigate("/add-work-schedule", {
                    state: {
                      entry: entry,
                      project: project,
                      position: selectPosition,
                    },
                  });
                }}
              >
                {t("Edit Work Schedule")}
              </LongBlueButton>
            )}
          <SearchingBoxContainer>
            <Grid container spacing={1.5}>
              <Grid item xs={12} sm={7}>
                <WorkDetailContainer>
                  <Box>
                    <ProjectBar
                      newEntry={false}
                      user={scheduleData?.data?.createdBy}
                      updatedOn={scheduleData?.data?.updatedOn}
                      updatedBy={scheduleData?.data?.updatedBy}
                      status={scheduleData?.data?.status}
                      riskAssessmentStatus={scheduleData?.data?.riskAssessmentStatus}
                    />
                  </Box>
                  <Box>
                    <WhiteContainer sx={{ height: "100%", minHeight: "400px" }}>
                      {isPositionLoaded && (
                        <BigMapCard
                          selectPosition={selectPosition}
                          isInput={false}
                          startTime={scheduleData?.data?.startTime}
                          endTime={scheduleData?.data?.endTime}
                          date={scheduleData?.data?.workDate}
                          project={project || projectData?.data}
                          schedule={entry}
                        />
                      )}
                    </WhiteContainer>
                  </Box>
                </WorkDetailContainer>
              </Grid>
              <Grid item xs={12} sm={5}>
                <WorkDetailContainer>
                  <Box>
                    {workType && (
                      <BigHeading>
                        {t("Work Type")}: {workType}
                      </BigHeading>
                    )}
                    {workType == "Confined Space" && (
                      <WhiteContainer
                        sx={{ height: "100%", minHeight: "300px" }}
                      >
                        <Box>
                          <BigHeading>{t("Document")}</BigHeading>
                          <Box sx={{ m: "20px" }}>
                            {/* Risk Assessment Section */}
                            <Box sx={{ mb: "24px" }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
                                <Box sx={{
                                  minWidth: '200px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  color: '#333'
                                }}>
                                  {t("Risk Assessment: ")}
                                </Box>
                              </Box>
                              <Box sx={{ ml: '20px' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                  {riskAssessmentFile && riskAssessmentFile.length === 0 && !riskAssessment && (
                                    <Box sx={{
                                      color: '#666',
                                      fontStyle: 'italic',
                                      p: 2,
                                      backgroundColor: '#f5f5f5',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd'
                                    }}>
                                      N/A
                                    </Box>
                                  )}
                                  {riskAssessmentFile && riskAssessmentFile?.map((file: File, index: number) => (
                                    <Box key={index} sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1,
                                      p: 1,
                                      backgroundColor: '#f9f9f9',
                                      borderRadius: '4px',
                                      border: '1px solid #e0e0e0',
                                      maxWidth: '100%',
                                      overflow: 'hidden'
                                    }}>
                                      {getLink(file)}
                                    </Box>
                                  ))}
                                  {riskAssessment && (
                                    <ShortBlueButton
                                      onClick={handleRiskAssessment}
                                      sx={{ alignSelf: 'flex-start', minWidth: '180px' }}
                                    >
                                      {t("View Risk Assessment")}
                                    </ShortBlueButton>
                                  )}
                                </Box>
                              </Box>
                            </Box>

                            {/* Work Permit Section */}
                            <Box sx={{ mb: "24px" }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
                                <Box sx={{
                                  minWidth: '200px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  color: '#333'
                                }}>
                                  {t("Work Permit: ")}
                                </Box>
                              </Box>
                              <Box sx={{ ml: '20px' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                  {workPermitFile && workPermitFile.length === 0 && !workPermit && (
                                    <Box sx={{
                                      color: '#666',
                                      fontStyle: 'italic',
                                      p: 2,
                                      backgroundColor: '#f5f5f5',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd'
                                    }}>
                                      N/A
                                    </Box>
                                  )}
                                  {workPermitFile && workPermitFile?.map((file: File, index: number) => (
                                    <Box key={index} sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1,
                                      p: 1,
                                      backgroundColor: '#f9f9f9',
                                      borderRadius: '4px',
                                      border: '1px solid #e0e0e0'
                                    }}>
                                      {getLink(file)}
                                    </Box>
                                  ))}
                                  {workPermit && (
                                    <ShortBlueButton
                                      onClick={handleWorkPermit}
                                      sx={{ alignSelf: 'flex-start', minWidth: '180px' }}
                                    >
                                      {t("View Work Permit")}
                                    </ShortBlueButton>
                                  )}
                                </Box>
                              </Box>
                            </Box>

                            {/* Equipment Checklist Section */}
                            <Box sx={{ mb: "24px" }}>
                              <Box sx={{ display: 'flex', alignItems: 'center', mb: '12px' }}>
                                <Box sx={{
                                  minWidth: '200px',
                                  fontWeight: 'bold',
                                  fontSize: '14px',
                                  color: '#333'
                                }}>
                                  {t("Equipment Checklist")}
                                </Box>
                              </Box>
                              <Box sx={{ ml: '20px' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                  {equipmentChecklist && equipmentChecklist.length > 0 ? equipmentChecklist?.map((file: File, index: number) => (
                                    <Box key={index} sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1,
                                      p: 1,
                                      backgroundColor: '#f9f9f9',
                                      borderRadius: '4px',
                                      border: '1px solid #e0e0e0'
                                    }}>
                                      {getLink(file)}
                                    </Box>
                                  )) : (
                                    <Box sx={{
                                      color: '#666',
                                      fontStyle: 'italic',
                                      p: 2,
                                      backgroundColor: '#f5f5f5',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd'
                                    }}>
                                      N/A
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </WhiteContainer>
                    )}
                  </Box>
                  <Box>
                    <WhiteContainer
                      sx={{ height: "100%", minHeight: "260px", mt: "20px" }}
                    >
                      <Box>
                        <BigHeading>{t("On Site Worker")}</BigHeading>
                        <Box sx={{ m: "10px" }}>
                          {workType == "Confined Space" && (
                            <>
                              <FormLongLabel
                                title={t("Competent person")}
                                content={
                                  scheduleData?.data?.workers.find(
                                    (worker: any) => worker.typeId === 1
                                  )?.name
                                }
                              />
                              <FormLongLabel
                                title={t("Standby Person")}
                                content={
                                  scheduleData?.data?.workers.find(
                                    (x: any) => x.typeId === 2
                                  )?.name
                                }
                              />
                            </>
                          )}

                          {scheduleData?.data?.workers
                            .filter((x: any) => x.typeId === 3)
                            .map((worker: any, index: number) => (
                              <FormLongLabel
                                key={index}
                                title={t(`Certified Worker ${index + 1}`)}
                                content={worker.name}
                              />
                            ))}
                        </Box>
                      </Box>
                    </WhiteContainer>
                  </Box>
                </WorkDetailContainer>
              </Grid>
            </Grid>
          </SearchingBoxContainer>
          <BigHeading>{t("On Site Equipment")}</BigHeading>
          <RecordTable
            columns={EquipmentColumns}
            rows={scheduleData?.data?.siteEquipments}
            checkbox={false}
          ></RecordTable>

          {scheduleData?.data?.workers
            .filter((x: any) => x.typeId === 3)
            .map((worker: any, index: number) => (
              <>
                <BigHeading>
                  {t("Certified Worker")} {index + 1}: {worker?.name}
                </BigHeading>
                <RecordTable
                  columns={EquipmentColumns}
                  rows={worker?.equipments}
                  checkbox={false}
                ></RecordTable>
              </>
            ))}
          {recordings?.data && (
            <>
              <BigHeading>{t("Recording")}</BigHeading>
              <RecordTable
                columns={[
                  {
                    field: "fromTime",
                    headerName: t("From Time"),
                    width: 200,
                    isSortable: false,
                    renderCell: (param: any) => formatDateTime(param.value),
                  },
                  {
                    field: "path",
                    headerName: t(""),
                    width: 200,
                    isSortable: false,
                    renderCell: (param: any) => {
                      return (
                        <a href={param.value} target="_blank">
                          View
                        </a>
                      );
                    },
                  },
                ]}
                rows={recordings?.data?.map((x: any, i: number) => ({
                  id: "recording_" + i,
                  ...x,
                }))}
                checkbox={false}
              />
            </>
          )}
          <Box sx={{ display: "row" }}>
            <BackButton onClick={() => navigate(`/entry`)}>
              {t("Back")}
            </BackButton>
          </Box>
        </ListContainer>
      </BackgroundStyle>
    </MainContent>
  );
};
export default EntryDetailPage;
